"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
// TODO: We need to be able to specify a size for these icons.
const ActionIcon = props => {
    const { name, color } = props;
    let icon = null; //return null if nothing else
    if (name && name.startsWith('fa')) {
        icon = React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: props.size, icon: name.split(/-(.*)/s, 2), color: color });
    }
    else {
        /*if (Object.keys(builtInActions).includes(name)) {
          icon = <img src={builtInActions[name].icon} alt={name} />;
        }*/
    }
    return React.createElement("div", { style: props.style }, icon);
};
exports.default = ActionIcon;
//# sourceMappingURL=ActionIcon.js.map